import { Products } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function ProductPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Products", href: "/products" },
          { title: "Edit Product", href: `/products/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Product</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Products.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
